import { Dialog } from "@mui/material";
import DialogContentSelectGeneric from "../../../../../../components/SelectsSimpleApiQuery/DialogsContents/DialogContentGeneric";
import {
  defValueProduto,
  TProduto,
} from "../../../../../../types/api/comercial/produtos";

export default function DialogProdutos({
  open,
  handleClose,
  value,
  onChange,
}: DialogProdutosProps) {
  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClose}>
      <DialogContentSelectGeneric
        {...{ handleClose }}
        multiple
        title="Selecionar produto"
        queryPath="/comercial/produtos/pesquisar-produtos"
        getItemKey={(item) => item.id}
        defaultValue={
          Array.isArray(value) && value.length > 0 ? value : [defValueProduto]
        }
        getItemLabel={(item) => `${item.nome}`}
        onChange={(value) => {
          onChange(value as TProduto[]);
          handleClose();
        }}
      />
    </Dialog>
  );
}

interface DialogProdutosProps {
  open: boolean;
  handleClose: () => void;
  value: TProduto[];
  onChange: (arg: TProduto[] | null) => void;
}
